module.exports = __webpack_public_path__ + "static/media/p059_cipher.c7dd028e.txt";